// Inspired by https://gist.github.com/saschb2b/bff67fc8462ee106fec22207ee2638c9

import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'

const options = {}
let currentPage = ''

export const trackPage = (page, propid, taid, name, brand) => {
  console.log(`GA - Tracking page ${page} with prop id ${propid}, taid ${taid}, name ${name}, brand ${brand}`);

  currentPage = page;

  ReactGA.set({ dimension1: propid, dimension2: taid, dimension3: name, dimension4: brand });
  ReactGA4.set({ dimension1: propid, dimension2: taid, dimension3: name, dimension4: brand });
  ReactGA.pageview(page);
  ReactGA4.send({ hitType: "pageview", page, title: name, brand });
}

export const googleAnalytics = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {

    // const nextPage = `${action.payload.pathname}${action.payload.search}`;
    const nextPage = action.payload.pathname.split( '/' )[1];
    const propid = store.getState().hotel.apiData.id;
    const taid = store.getState().hotel.apiData.ta_id;
    const name = store.getState().hotel.apiData.name;
    const brand = store.getState().hotel.apiData.template;

    if (propid && currentPage !== nextPage) {
      trackPage(nextPage, propid, taid, name, brand);
    }
  }

  return next(action)
}



// WEBPACK FOOTER //
// ./stores/reactGaMiddleware.js